import report from './report';
import materials from './materials';

export default {
    report,
    materials,
};
